export const routeData = {
    VEHICLE: {
        name: "vehicle",
        path: "/vehicle",
    },
    VEHICLE_DAMAGE: {
        name: "vehicle-damage",
        path: "/vehicle-damage",
    },
    ESTIMATE: {
        name: "estimate",
        path: "/estimate",
    },
    ADDRESS_LOOKUP: {
        name: "address-lookup",
        path: "/address-lookup",
    },
    VIN_LOOKUP: {
        name: "vin-lookup",
        path: "/vin-lookup",
    },
    LICENSE_PLATE_LOOKUP: {
        name: "license-plate-lookup",
        path: "/license-plate-lookup",
    },
    SERVICE_ZIP: {
        name: "service-zip",
        path: "/service-zip",
    },
    ADDRESS_VEHICLES: {
        name: "address-vehicles",
        path: "/address-vehicles",
    },
    VEHICLE_PARTS: {
        name: "vehicle-parts",
        path: "/vehicle-parts",
    },
    PART_QUESTIONS: {
        name: "part-questions",
        path: "/part-questions",
    },
    MOLDING_QUESTIONS: {
        name: "molding-questions",
        path: "/molding-questions",
    },
    CAPABILITY_QUESTIONS: {
        name: "capability-questions",
        path: "/capability-questions",
    },
    QUOTE: {
        name: "quote",
        path: "/quote",
    },
    POLICY_INFO: {
        name: "policy-info",
        path: "/policy-info",
    },
    INSURANCE_DETAILS: {
        name: "insurance-details",
        path: "/insurance-details",
    },
    DUPLICATE_CHECK: {
        name: "duplicate-check",
        path: "/duplicate-check",
    },
    POLICY_VEHICLE: {
        name: "policy-vehicle",
        path: "/policy-vehicle",
    },
    POLICY_DRIVER: {
        name: "policy-driver",
        path: "/policy-driver",
    },
    ENDORSEMENTS: {
        name: "endorsements",
        path: "/endorsements",
    },
    POLICY_INFO_SUBMITTED: {
        name: "policy-info-submitted",
        path: "/policy-info-submitted",
    },
    RECALIBRATION_INFO: {
        name: "recalibration-info",
        path: "/recalibration-info",
    },
    COVERAGE_STATEMENT: {
        name: "coverage-statement",
        path: "/coverage-statement",
    },
    VERIFY_DETAILS: {
        name: "verify-details",
        path: "/verify-details",
    },
    INSURANCE_COMPANY: {
        name: "insurance-company",
        path: "/insurance-company",
    },
    SERVICE_LOCATION: {
        // keep even though this page has been removed from the regular flow bc Heritage still points to it
        name: "service-location",
        path: "/service-location",
    },
    HERITAGE: {
        name: "heritage",
        path: "/virtual/heritage",
        virtual: true,
    },
    SCHEDULE: {
        name: "schedule",
        path: "/schedule",
    },
    SCHEDULING: {
        name: "scheduling",
        path: "/scheduling",
    },
    MOBILE_DETAILS: {
        name: "mobile-details",
        path: "/mobile-details",
    },
    CUSTOMER_DETAILS: {
        name: "customer-details",
        path: "/customer-details",
    },
    PAYMENT_METHOD: {
        name: "payment-method",
        path: "/payment-method",
    },
    PAYMENT: {
        name: "payment",
        path: "/payment",
    },
    PAYMENT_PIA_RETURN: {
        name: "payment-pia-return",
        path: "/payment-pia-return",
    },
    PAYMENT_ADYEN: {
        name: "payment-adyen",
        path: "/payment-adyen",
    },
    PAYMENT_ADYEN_RETURN: {
        name: "adyen-return",
        path: "/virtual/payment/return",
        virtual: true,
    },
    CONFIRMATION: {
        name: "confirmation",
        path: "/confirmation",
    },
    RETURN_USER: {
        name: "return-user",
        path: "/return-user",
    },
    LOAD_SESSION: {
        name: "load-session",
        path: "/virtual/load-session",
        virtual: true,
    },
    LANDING: {
        name: "landing",
        path: "/",
        virtual: true,
    },
    AUTO_ROUTE: {
        name: "auto-route",
        path: "/virtual/auto-route",
        virtual: true,
    },
    ERROR: {
        name: "error",
        path: "/virtual/error",
        virtual: true,
    },
    RESTART: {
        name: "restart",
        path: "/virtual/restart",
        virtual: true,
    },
    BAILOUT: {
        name: "bailout",
        path: "/bailout",
    },
    BAILOUT_SUCCESS: {
        name: "bailout-success",
        path: "/bailout-success",
    },
};

export const FUNNEL_START_PAGE = routeData.VEHICLE;
